import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const pages = [
    {
      path: '/fundamental-signals',
      title: 'Fundamental Signals',
      description: 'Stock recommendations combining fundamental analysis with WaveTrend momentum'
    },
    {
      path: '/multi-strategy-signals',
      title: 'Multi-Strategy Signals',
      description: 'Real-time trading signals across multiple strategies with interactive charts and watchlists'
    },
    {
      path: '/swing',
      title: 'Swing Trading',
      description: 'ML-based bottom detection strategies for TQQQ, UPRO, SOXL with live entry signals'
    },
    {
      path: '/leveraged.html',
      title: 'Leveraged ETF Dashboard',
      description: 'TQQQ/UPRO strategy comparison and performance tracking',
      external: true
    },
    {
      path: '/wavetrend-signals.html',
      title: 'WaveTrend Signals',
      description: 'WaveTrend strategy signals and analysis',
      external: true
    },
    {
      path: '/professional-momentum.html',
      title: 'Professional Momentum',
      description: 'Advanced momentum-based trading signals',
      external: true
    }
  ];

  return (
    <div className="landing-page">
      <div className="landing-header">
        <h1>Vectrax</h1>
        <p className="landing-subtitle">Professional Trading Strategy Analysis</p>
      </div>

      <div className="pages-grid">
        {pages.map((page) => (
          <div key={page.path} className="page-card">
            {page.external ? (
              <a href={page.path} className="page-link">
                <h2>{page.title}</h2>
                <p>{page.description}</p>
                <span className="page-arrow">→</span>
              </a>
            ) : (
              <Link to={page.path} className="page-link">
                <h2>{page.title}</h2>
                <p>{page.description}</p>
                <span className="page-arrow">→</span>
              </Link>
            )}
          </div>
        ))}
      </div>

      <footer className="landing-footer">
        <p>Select a page above to view detailed trading analysis and signals</p>
      </footer>
    </div>
  );
}

export default LandingPage;
